import { render, staticRenderFns } from "./BoneList.vue?vue&type=template&id=d24eb41c&scoped=true"
import script from "./BoneList.vue?vue&type=script&lang=js"
export * from "./BoneList.vue?vue&type=script&lang=js"
import style0 from "./BoneList.vue?vue&type=style&index=0&id=d24eb41c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24eb41c",
  null
  
)

export default component.exports